export default (el) => el.focus();
